import { render, staticRenderFns } from "./BOCPTLHM.vue?vue&type=template&id=76803f64&scoped=true"
import script from "./BOCPTLHM.vue?vue&type=script&lang=js"
export * from "./BOCPTLHM.vue?vue&type=script&lang=js"
import style0 from "./BOCPTLHM.vue?vue&type=style&index=0&id=76803f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76803f64",
  null
  
)

export default component.exports